import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 16,
		height: 16,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function CloseIcon(props) {
	return (
		<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M6.06648 6.00001L18.0664 17.9883" stroke={props.fill} strokeWidth="2" strokeLinecap="round" />
			<path d="M18.0531 6.00001L6.08101 18" stroke={props.fill} strokeWidth="2" strokeLinecap="round" />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<CloseIcon fill={props.fill} />
		</div>
	);
}